export default "__VITE_ASSET__BbM3IvuA__"